import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const username = localStorage.getItem('USERNAME');
  const password = localStorage.getItem('PASSWORD');

  if (!username || !password) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;


